import { Component } from '@angular/core';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { NavParams, NavController, ModalController, LoadingController, ToastController } from 'ionic-angular';

import { Video } from '../../model/video';

@Component({
    selector: 'page-video-popup',
    templateUrl: 'video-popup.html'
})
export class VideoPopupPage {
    video: Video;

    popoverActive: boolean = false;

    constructor(navParams : NavParams, private loadingCtrl: LoadingController, private nav: NavController,
            private toast: ToastController, private photoLibrary: PhotoLibrary) {
        this.video = navParams.get("video");
    }

    download() {
        if (this.popoverActive)
            return;
        
        this.popoverActive = true;
        
        let loading = this.loadingCtrl.create({
            content: 'Downloading video...',
        });

        loading.present();
        this.photoLibrary.requestAuthorization().then(() => {
            this.photoLibrary.saveVideo(this.video.url, "NextGenRodeo").then(data => {
                loading.dismiss();
                this.popoverActive = false;

                const toast = this.toast.create({
                    message: "Video saved!",
                    duration: 3000,
                    position: 'bottom',
                });

                toast.present();
                this.back();
            }, err => {
                this.popoverActive = false;
                console.log('Error saving video.')
                loading.dismiss();
            });
          }).catch(err => {
            this.popoverActive = false;
            console.log('permissions weren\'t granted');
            loading.dismiss();
        });
    }

    back() {
        this.nav.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/videos/video-popup.ts